'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import Formsy from 'formsy-react';
import utils from 'services/utils';

import ModalHeader from 'components/base/ModalHeader';
import ModalBody from 'components/base/ModalBody';
import ModalFooter from 'components/base/ModalFooter';
import modalActions from 'actions/ModalActionCreators';

const propTypes = {
    showCloseButton: PropTypes.bool,
};

const defaultProps = {
    showCloseButton: false,
};

class ConfirmationModalContent extends React.Component {
    constructor(props) {
        super(props);
        this.handleOkButtonClick = this.handleOkButtonClick.bind(this);
    }

    handleOkButtonClick(model, event) {
        if (this.props.callbackFunction) {
            this.props.callbackFunction();
        }
    	modalActions.hideModal();
    }

    render() {
        return (
            <Formsy onValidSubmit={this.handleOkButtonClick}>
                <ModalHeader showCloseButton={this.props.showCloseButton}>{this.props.header}</ModalHeader>

                <ModalBody>
                    <div>
                        {this.props.message}
                    </div>
                </ModalBody>

                <ModalFooter>
                    <div className="modal-footer">
                        <button className="button--primary " type="submit">Ok</button>
                    </div>
                </ModalFooter>
            </Formsy>
        );
    }
}

export default ConfirmationModalContent; 